export const MOCK_DNS_RESPONSE = [
  {
    id: 'mock-dns-1',
    host: 'mail.example.com',
    data: {
      spf: {
        title: 'SPF Record',
        status: 'pass',
        detail: 'v=spf1 include:_spf.google.com ~all',
        description: 'SPF record is properly configured, authorising Google mail servers.',
        data: ['v=spf1 include:_spf.google.com ~all'],
      },
      dkim: {
        title: 'DKIM',
        status: 'pass',
        detail: 'DKIM key found for selector "google".',
        description: 'DomainKeys Identified Mail is configured and valid.',
        data: [],
      },
      dmarc: {
        title: 'DMARC',
        status: 'fail',
        detail: 'No DMARC record found.',
        description: 'Domain-based Message Authentication, Reporting & Conformance is not configured. Add a _dmarc TXT record.',
        data: [],
      },
      mx: {
        title: 'MX Records',
        status: 'pass',
        detail: 'MX records found and resolving.',
        description: 'Mail exchange records are correctly configured.',
        data: ['10 aspmx.l.google.com', '20 alt1.aspmx.l.google.com'],
      },
      reverse_dns: {
        title: 'Reverse DNS (PTR)',
        status: 'pass',
        detail: 'PTR record resolves to mail.example.com.',
        description: 'Reverse DNS lookup matches forward DNS, improving deliverability.',
        data: ['mail.example.com'],
      },
    },
  },
  {
    id: 'mock-dns-2',
    host: 'smtp.example.com',
    data: {
      spf: {
        title: 'SPF Record',
        status: 'error',
        detail: 'SPF record has too many DNS lookups (>10).',
        description: 'Reduce the number of SPF include mechanisms to avoid exceeding the DNS lookup limit.',
        data: [],
      },
      dkim: {
        title: 'DKIM',
        status: 'fail',
        detail: 'No DKIM key found.',
        description: 'DKIM is not configured on this server.',
        data: [],
      },
      dmarc: {
        title: 'DMARC',
        status: 'pass',
        detail: 'v=DMARC1; p=quarantine; rua=mailto:dmarc@example.com',
        description: 'DMARC is configured with quarantine policy.',
        data: ['v=DMARC1; p=quarantine; rua=mailto:dmarc@example.com'],
      },
    },
  },
]
